module.exports = {"en":{"attention":"Attention","error":"Error","warning":"Warning","externalLink":"Open External Link"},"de":{"attention":"Achtung","error":"Fehler","warning":"Warnung","externalLink":"Externe Links öffnen"},"fr":{"attention":"Attention","error":"Erreur","warning":"Avertissement","externalLink":"Ouvrir le lien externe"},"ru":{"attention":"Внимание","error":"Ошибка","warning":"Предупреждение","externalLink":"Переход по внешней ссылке"}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/common.localization.json
// module id = 215
// module chunks = 0